import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { itemStatusData } from "../../../../data";

const { TextArea } = Input;

const AddAssetTransferModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);
  const { fixedAssetsData} = useSelector((state) => state.dropdown);
  const { personnelFolders} = useSelector((state) => state.folder);
  const [itemCode ,setItemCode] = useState(prodd?.atAssetCode)
   
  const handleChange  = (item)=>{
    setItemCode(item)
  }
   
  
  const onFinish = async (data) => {
    data.atId = prodd ? prodd?.atId : null; 
    data.atAssetCode = itemCode
    const res = await dispatch(
      save({
        ...data,
        url: "asset/saveAssetTransfer.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => { 
    if (prodd) { 
      form.setFieldsValue(prodd); 
    }  else {
      form.resetFields();  
    }
  }, [prodd]); 


  useEffect(()=>{
    setItemCode(prodd?.atAssetCode ?? null)
  },[prodd?.atAssetCode ?? null])
  console.log("personnelFolders",personnelFolders)
 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd ? `Edit asset transfer ${prodd?.srItemName}` : "Add asset transfer details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}  
        >
             <Form.Item
            name="atAssetId"
            className=""
            label={<span>Asset</span>}
            rules={[
              {
                required: true,
                message: "Please select asset",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                fixedAssetsData?.length > 0 &&
                fixedAssetsData?.map((item) => ({
                  value: item?.faId,
                  label: item?.faName,
                }))
              }
              onChange={(value)=>{
                const item  =  fixedAssetsData && fixedAssetsData?.find((item)=>item?.faId === value)
                handleChange(item?.faCode)
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>

          <Form.Item
            name="atTransferFrom"
            className=""
            label={<span>From</span>}
            rules={[
              {
                required: true,
                message: "Please select from",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: item?.ppFullname,
                }))
              } 
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>

          <Form.Item
            name="atTransferTo"
            className=""
            label={<span>To</span>}
            rules={[
              {
                required: true,
                message: "Please select to",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: item?.ppFullname,
                }))
              } 
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>
      
          <Form.Item
            name="atComments"
            label="Comments"
            rules={[
              {
                required: true,
                message: "Enter comments",
              },
            ]}
          >
            <TextArea  rows={6} className="input" />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddAssetTransferModal;
